import React from 'react';
import { usePortalCreateContext } from '../../../../jira-common/context';
// Renders the Knowledge base article suggestions on the portal create page and null on other pages
export var KbSuggestionFieldWrapper = function KbSuggestionFieldWrapper(_ref) {
  var questionStore = _ref.questionStore;
  var _usePortalCreateConte = usePortalCreateContext(),
    KbSuggestionField = _usePortalCreateConte.KbSuggestionField;
  return questionStore.formQuestion.jiraField === 'summary' && KbSuggestionField ? /*#__PURE__*/React.createElement(KbSuggestionField, null) : null;
};